import axios from "../utils/axiosConfig";

const logService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/logs", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/logs/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
};

export default logService;
